/**
 * Handle easy extraction option selection
 */
export enum ExtractHelper {
  INACTIVITY_REPORT = 0,
  BACTH = 1
}
